import moment from 'moment';

export default function minOpenCaseDate() {
  return moment('2012-01-01', 'YYYY-MM-DD').utc();
}
